import React, { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { Divider, Table, Popconfirm, Card, Tooltip, Switch, Input, Button, Tag, Row, Col, Drawer, InputNumber, DatePicker, Form, Select } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, RightSquareOutlined, EyeOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
import { ColumnProps } from 'antd/lib/table';
import { Link } from 'react-router-dom';
import { HrmsEmployeeDetailsDto } from '@gtpl/shared-models/masters'
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import Highlighter from 'react-highlight-words';
import { ApplyForLeavesDto, ApplyForOdCoDto, ApplyOdCoFilter } from '@gtpl/shared-models/hrms';
import { ApplyForLeavesService } from '@gtpl/shared-services/hrms';
import { ApplyForLeavesForm } from '@gtpl/pages/hrms/hrms-components/apply-for-leaves-form'
import moment from 'moment';
import './apply-for-leaves-grid.css';
import { HrmsEmployeeRequest } from '@gtpl/shared-models/masters';
import { HrmsEmpDetService } from '@gtpl/shared-services/masters';

/* eslint-disable-next-line */


export function ApplyForOdCoGrid(
 
) {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [applyForLeavesData, selectedApplyForLeavesData] = useState<ApplyForOdCoDto[]>([]);
  const [selectedLeave, setSelectedLeave] = useState<any>(undefined);
  const [employeeData, setEmployeeData] = useState<HrmsEmployeeDetailsDto[]>([]);
  const applyForLeavesService = new ApplyForLeavesService();
  const [form] = Form.useForm();
  const { Option } = Select;

  // const openFormWithData = (viewData : HrmsEmployeeDetailsDto)=>{
  //   setDrawerVisible(true);
  //   setEmployeeData(viewData);
  // }
  const hrmsEmpDetService = new HrmsEmpDetService;

  // useEffect(() => {
  //   getCoOd();
  // }, []);

  /**
   * 
   */
//   const getCoOd = () => {
    
//     applyForLeavesService.getCoOd().then(res => {
//       if (res.status) {
//         res.data.forEach((LeaveApproval) => {
//           const req = new HrmsEmployeeRequest(LeaveApproval.employeeId);
//           hrmsEmpDetService.getActiveEmployeesById(req).then(res => {
//             LeaveApproval.employeeName = res.data.employeeName;
//           })
//           console.log(LeaveApproval.employeeId);
//         });
//         selectedApplyForLeavesData(res.data);
//       } else {
//         if (res.intlCode) {
//           selectedApplyForLeavesData([]);
//           AlertMessages.getErrorMessage(res.internalMessage);
//         } else {
//           AlertMessages.getErrorMessage(res.internalMessage);
//         }
//       }
//     }).catch(err => {
//       selectedApplyForLeavesData([]);
//       AlertMessages.getErrorMessage(err.message);
//     })
//   }


const getCoOd = () => {
    form.validateFields().then(values => {
      const {type} = values;
      const leaveType=type;
      const typeReq = new ApplyOdCoFilter(leaveType);

      applyForLeavesService.getCoOd(typeReq).then((res) => {
        if (res.status) {
            selectedApplyForLeavesData(res.data);
        } else {
            selectedApplyForLeavesData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }).catch(err => {
        selectedApplyForLeavesData([]);
        AlertMessages.getErrorMessage(err.message);
      });
    });
  };

  /**
   * 
   * @param applyForLeavesData 
   */

  /**
     * 
     * @param variantData 
     */
  /**
   * 
   * @param dataIndex 
   */

  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      ) : null
  });
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };
  const closeDrawer = () => {
    setDrawerVisible(false);
  }

  const onFinish = (values: any) => {
    getCoOd();
  };

  const onReset = () => {
    form.resetFields();
    getCoOd();
  };

  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      responsive: ['sm'],
      render: (text, object, index) => (page - 1) * 10 + (index + 1)
    },
    {
      title: 'Employee Code',
      dataIndex: 'employeeCode',
      // responsive: ['lg'],
      sorter: (a, b) => a.employeeCode?.localeCompare(b.employeeCode),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('employeeCode')
    },
    {
      title: 'Employee Name',
      dataIndex: 'employeeName',
      // responsive: ['lg'],
      sorter: (a, b) => a.employeeName?.localeCompare(b.employeeName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('employeeName')
    },
    {
      title: 'Type',
      dataIndex: 'type',
      // responsive: ['lg'],
      sorter: (a, b) => a.typeOfLeave?.localeCompare(b.type),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('type')
    },
    {
      title: 'From Date',
      dataIndex: 'fromDate',
      render: (text, record) => { return moment(record.fromDate).format('YYYY-MM-DD') },
      sorter: (a, b) => a.fromDate.localeCompare(b.fromDate),
      sortDirections: ['descend', 'ascend'],

    },
    {
      title: 'To Date',
      width: 100,
      dataIndex: 'toDate',
      render: (text, record) => { return moment(record.toDate).format('YYYY-MM-DD') },
      sorter: (a, b) => a.toDate.localeCompare(b.toDate),
      sortDirections: ['descend', 'ascend'],

    },
    {
      title: "Leave Reason",
      dataIndex: "leaveReason"
    },

    {
      title: 'NO of Days',
      dataIndex: 'noOfDays',
      responsive: ['lg'],
      sorter: (a, b) => a.noOfDays.localeCompare(b.noOfDays),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('noOfDays'),

    },
  ];


  /**
   * 
   * @param pagination 
   * @param filters 
   * @param sorter 
   * @param extra 
   */
  const onChange = (pagination, filters, sorter, extra) => {
    console.log('params', pagination, filters, sorter, extra);
  }

  return (

    <Card title={<span style={{ color: 'white' }}>Apply OD/CO</span>}
      style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
      extra={
        <>
        <Link to='/apply-for-od-co' >
          <span style={{ color: 'white' }} >
            <Button className='panel_button' >Create </Button> </span>
        </Link>
        </>
      }
        >
             <Form form={form} layout="horizontal" onFinish={onFinish}>
             <Row gutter={22}>
             <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item label="Type" name='type' required={true}>
              <Select
                showSearch
                placeholder="Select Type"

              >
                <Option value="OD">OD</Option>
                <Option value="CO">CO</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 3 }}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 1 }}>
            <Form.Item>
              <Button type="primary" htmlType="reset" onClick={onReset}>
                Reset
              </Button>
            </Form.Item>
          </Col>
          </Row>
             </Form>

      <br></br>
      <Row gutter={40}></Row>
      <br></br>
      <br></br>
      <Table

        rowKey={record => record.holidayId}
        columns={columnsSkelton}
        dataSource={applyForLeavesData}
        scroll={{ x: true }}
        pagination={{
          onChange(current) {
            setPage(current);
          }
        }}
        onChange={onChange}
        bordered />
    </Card>
  );
}

export default ApplyForOdCoGrid;
